import React, { useEffect, useState } from "react";
import FormHeading from "../../../Components/FormComponents/FormHeading";
import StepButtons from "../../../Components/FormComponents/StepButtons";
import { Text4 } from "../../../Components/FormComponents/InputFields";
import { useForm } from "react-hook-form";
import { Button, Col, notification, Row } from "antd";
import { BankDetailAPI } from "../../../Services/EmployeeOnboarding";
import { useNavigate, useOutletContext } from "react-router-dom";
import ApproveReject from "./Component/ApproveReject";
import axios from "axios";

export default function BankDetails({ current, setCurrent }) {
  const {
    control,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm();
  const { responseData, id, profileData } = useOutletContext();
  const [disabledFields, setDisabledFields] = useState("");

  const [validate, setValidate] = useState();
  const [validateData, setValidateData] = useState();
  const [isUpdate, setIsUpdate] = useState(false)

  const navigate = useNavigate(null);
  const [api, contextHolder] = notification.useNotification();

  const onSubmit = async (val) => {
    try {
      const res = await BankDetailAPI(val,id,isUpdate);
      console.log("Bank details submitted:", res.data);
      if (res.data?.success) {

       
      if(isUpdate) {
          setIsUpdate(false)
           api.success({
            message: res?.data?.message ,
            placement: "top",
          });
          return

      }
     else if (responseData?.final_submit) {
          handleSubmitFinal();
        } else {
          navigate("/new-user/documents");
        }
        navigate("/new-user/documents");
      } else {
        if (res?.data?.message === "Bank details already updated") {
          if(!isUpdate) {
            navigate("/new-user/documents");
          }else {
             api.error({
            message: res?.data?.message,
            placement: "top",
          });
          }
          
        } else {
          api.error({
            message: res?.data?.message || "Something went wrong",
            placement: "top",
          });
          return null;
        }

        // throw new Error(
        //   "Submission failed: " + (res.data?.message || "Unknown error")
        // );
      }
    } catch (error) {
      console.error("Error submitting bank details:", error);
    }
  };
  const handleSubmitFinal = async () => {
    const { data } = await axios.post("/api/employees/final-submit", {
      final_submit: true,
    });

    if (data?.success) {
      api.success({
        message: data?.message,
        placement: "top",
      });
      navigate("/new-user/documents");
    } else {
      api.error({
        message: data?.message,
        placement: "top",
      });
    }

    console.log("hellow");
  };
  const type = sessionStorage.getItem("userType");

  const checkAccount = async () => {
    const { account_number, ifsc_code } = getValues();

    if (!account_number || !ifsc_code) {
      api.warning({
        message: "Account Number and IFSC Code are required",
        placement: "top",
      });
      return;
    }

    try {
      setValidate(true);
      const { data } = await axios.post(
        "/api/employee-connect/employee/acc_check",
        {
          account_number,
          ifsc_code,
        }
      );

      if (data?.success) {
        setValidateData(data?.data);
        api.success({
          message: data?.message,
          placement: "top",
        });
        // if (
        //   data?.data?.full_name ===
        //   responseData?.aadhar_response_data?.full_name
        // ) {
        //   setValidateData(data?.data);
        //   api.success({
        //     message: "Account validated successfully",
        //     placement: "top",
        //   });
        // } else {
        //   api.error({
        //     message:
        //       "Aadhaar number does not match the provided bank account holder name.",
        //     placement: "top",
        //   });
        // }
      } else {
        api.error({
          message: data?.message || "Validation failed",
          placement: "top",
        });
      }
    } catch (error) {
      api.error({
        message: error?.response?.data?.message || "Error validating account",
        placement: "top",
      });
    } finally {
      setValidate(false);
    }
  };

  useEffect(() => {
    const disableFields = {};
    const getValue = (path) => {
      const getNestedValue = (obj, pathArr) => {
        return pathArr.reduce(
          (acc, key) => (acc && acc[key] !== undefined ? acc[key] : null),
          obj
        );
      };
      const profileVal = getNestedValue(profileData, path);
      const responseVal = getNestedValue(responseData, path);
      const fieldKey = path.join(".");

      if (
        profileVal !== null &&
        profileVal !== undefined &&
        profileVal !== ""
      ) {
        disableFields[fieldKey] = true;
        return profileVal;
      }

      return responseVal;
    };

    const updatedValues = {
      account_number: getValue(["bank_details", "account_number"]),
      bank_name: getValue(["bank_details", "bank_name"]),
      beneficiary_name: getValue(["bank_details", "beneficiary_name"]),
      branch_address: getValue(["bank_details", "branch_address"]),
      branch_name: getValue(["bank_details", "branch_name"]),
      ifsc_code: getValue(["bank_details", "ifsc_code"]),
    };

    setDisabledFields((prev) => ({
      ...prev,
      ...disableFields,
    }));

    reset(updatedValues);
  }, [reset, responseData, profileData]);

  const { bank_details_meta } = responseData?.final_submit || {};

  const is_Final_submit = bank_details_meta?.final_submit === true;
  const is_approve = bank_details_meta?.is_approved === true;

  return (
    <>
      {contextHolder}
      <form
        className="responsive-form h-full"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Row className="align-content-start  w-full ">
           <Col className="flex justify-between" span={24}> 
                      <h3 className="color-heading">Bank Account Details</h3>
          
                       {isUpdate &&  <Button onClick={()=>setIsUpdate(false)}  style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }} shape="circle" icon={ <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                          </svg> }> 
                   </Button>||  <Button onClick={()=>setIsUpdate(true)}  style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }} shape="circle" icon={<svg  xmlns="http://www.w3.org/2000/svg" width="16"  fill="currentColor" className="bi bi-pencil-fill m-auto " viewBox="0 0 16 16">
                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                      </svg>}> 
                   </Button> }
                  
                    </Col>
                          
          <div className="w-full flex">
            <Text4
              control={control}
              id="account_number"
              name="Account Number"
              disabled={disabledFields["bank_details.account_number"]}
              errors={errors}
              validations={{
                required: true,
              }}
            />
            <Text4
              control={control}
              id="ifsc_code"
              name="IFSC Code"
              disabled={disabledFields["bank_details.ifsc_code"]}
              errors={errors}
              validations={{
                required: true,
              }}
            />

            {type !== "admin" &&
              ((validateData?.account_exists && (
                <Button
                  onClick={checkAccount}
                  type="success"
                  disabled={true}
                  className="self-end mb-3 bg-green-500 font-semibold text-white"
                >
                  Verified
                </Button>
              )) || (
                <Button
                  onClick={checkAccount}
                  type="success"
                  className="self-end mb-3 bg-green-500 font-semibold text-white"
                >
                  Verify
                </Button>
              ))}
          </div>
          <div className="w-full">
            {validateData && (
              <div className="flex ml-3">
                <div className="flex">
                  <div className="mb-2 ">Acc. Holder Name: &nbsp;</div>
                  <div className="text-sm">
                    <b>{validateData?.full_name || "-"}</b>
                  </div>
                </div>
                <div className="flex ml-3" span={5}>
                  <div className="mb-2 ">Account Exists:</div>
                  <div className="text-sm">
                    {validateData?.account_exists === true ? (
                      <span className="font-semibold text-green-600">
                        {" "}
                        &nbsp;YES
                      </span>
                    ) : validateData?.account_exists === false ? (
                      <span className="font-semibold text-red-600"> NO</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <Text4
            control={control}
            id="beneficiary_name"
            name="Account Holder's Name"
            // disabled={disabledFields["bank_details.beneficiary_name"]}
            disabled={false}
            errors={errors}
            validations={{
              required: true,
            }}
          />
          <Text4
            control={control}
            id="bank_name"
            name="Bank Name"
            disabled={disabledFields["bank_details.bank_name"]}
            errors={errors}
            validations={{
              required: true,
            }}
          />
          <Text4
            control={control}
            id="branch_name"
            disabled={disabledFields["bank_details.branch_name"]}
            name="Branch Name"
            errors={errors}
            validations={{
              required: true,
            }}
          />

          <Text4
            control={control}
            id="branch_address"
            name="Branch Address"
            disabled={disabledFields["bank_details.branch_address"]}
            errors={errors}
            validations={{
              required: true,
            }}
          />
        </Row>
        <Row className="step-buttons-box justify-content-end pt-3 px-2">
          {type !== "admin" && (
            <>
              {(is_Final_submit && (
                <button
                  disabled={true}
                  className="m-2 text-white step-button"
                  type="submit"
                >
                  Submit
                </button>
              )) || (
                <button
                  disabled={validateData?.account_exists !== true}
                  className="m-2 text-white step-button"
                  type="submit"
                >
                  Submit
                </button>
              )}
            </>
          ) || <>
          {  isUpdate && 
                <button
                 
                  className="m-2 text-white step-button"
                  type="submit"
                >
                  Update
                </button>}
         </> }
        </Row>
      </form>

      {type === "admin" && is_Final_submit && (
        <>
          {is_approve !== true && (
            <ApproveReject
              id={id}
              redirect="documents"
              detailType={["bank_details"]}
            />
          )}
        </>
      )}
    </>
  );
}
